import React from 'react';

const CampoEditableNumero = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;
  const largo = props.largo;

  const onChangeHandler = (event) => {
    const valor = event.target.value;
    const valorNumerico = Number(valor.replace(/\D/g, ''));
    if (!largo || valorNumerico.toString().length <= largo) {
      if (valor === '') {
        props.onChange(nombre, null);
      } else {
        props.onChange(nombre, valorNumerico);
      }
    }
  };

  let campo = '';
  campo = editar ? (
    <input
      className={`${estilo}`}
      key={nombre}
      value={valor ? valor : ''}
      onChange={onChangeHandler}
    />
  ) : (
    valor
  );

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoEditableNumero;
